const KEY = "vh_admin_api_bearer";

export function getAdminApiToken() {
  try {
    return sessionStorage.getItem(KEY) || "";
  } catch {
    return "";
  }
}

export function setAdminApiToken(token) {
  try {
    if (token) sessionStorage.setItem(KEY, token);
    else sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export function clearAdminApiToken() {
  setAdminApiToken("");
}
